<template>
  <main class="content">
    <!-- content -->
    <section class="intro-3">
      <div class="container">
        <div class="intro-3__wrapper">
          <h1 class="intro-3__title">{{service.name}}</h1>
          <p class="intro-3__text" v-if="service.cf[363]">{{service.cf[363]}}</p>
        </div>
      </div>
    </section>

    <section class="work" v-if="service.cf[364] || service.cf[365] || service.cf[366] || service.cf[367] || service.cf[368] || service.cf[369] || service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
      <div class='container'>
        <div class="work__wrapper">
          <div class="work__top top-work" v-if="service.cf[364] || service.cf[365] || service.cf[366]">
            <div class="top-work__text" v-if="service.cf[364] || service.cf[365]">
              <h2 class="top-work__title" v-if="service.cf[364]">{{service.cf[364]}}</h2>
              <slot v-if="service.cf[365]">
                <p class="top-work__subtitle" v-if="cf" v-for="(cf, i) in service.cf[365].split('\n')" :key="i">{{cf}}</p>
              </slot>
            </div>
            <div id="youtubeModal">
              <div class="top-work__right youtube" id="div1" v-if="service.cf[366] && service.id != 34117" :src="service.cf[366]">
                <!-- <iframe class="top-work__video" :src="service.cf[366]"></iframe> -->
              </div>
            </div>
          </div>
          <div class="work__down down-work" v-if="service.cf[367] || service.cf[368] || service.cf[369] || service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
            <div class="down-work__text">
              <p class="down-work__subtitle-text" v-if="service.id != 34117">Итак, документ готов. Теперь идем в суд.<br>
                От нас Вы получите простую и понятную памятку Ваших действий.</p>
              <p class="down-work__subtext" v-if="service.cf[367]">{{service.cf[367]}}</p>
              <h3 class="down-work__title" v-if="service.cf[368]">{{service.cf[368]}}</h3>
              <span class="down-work__subtitle" v-if="service.cf[369]">{{service.cf[369]}}</span>
              <ul class="down-work__list" v-if="service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
                <li v-if="service.cf[370]"><span>1</span> {{service.cf[370]}}</li>
                <li v-if="service.cf[371]"><span>2</span> {{service.cf[371]}}</li>
                <li v-if="service.cf[372]"><span>3</span> {{service.cf[372]}}</li>
                <li v-if="service.cf[373]"><span>4</span> {{service.cf[373]}}</li>
                <li v-if="service.cf[374]"><span>5</span> {{service.cf[374]}}</li>
              </ul>
            </div>
          <div class="work__down-img"></div>

          </div>
        </div>
        <div class="invisible-docs" v-if="service.html">
          <span class="invisible-docs__arr">></span>
          <div class="text">
            <div id="one" class="mydiv1" v-html="service.html"></div>
            <div id="two" class="mydiv2">
              <div class="invisible-docs__title">
                <p>Вам доступно 30% материала <br/><span>Для продолжения чтения выбирите подписку</span></p>
                <span class="invisible-docs__title-next"> > </span>
              </div>
              <div class="toggle"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="cards">
      <div class='container'>
        <div class="cards__wrapper">
          <h2 class="cards__title" v-if="!(service.html)" id="ya1">Не нужны дорогостоящие юристы</h2>
          <div class="cards__box box-cards">
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[375]">{{service.cf[375]}}</h4>
              <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[376]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[376].split('\n')" :key="i">{{cf}}</li>
                  </slot>
                  <li v-else>10 комплектов документов, с шаблонами которых наши клиенты уже выигрывали дела</li>
                </ul>

                <p class="box-item__text" v-if="service.cf[377]">{{service.cf[377]}}</p>
                <p class="box-item__text" v-else>Это популярный тариф – вам нужно потратить пару часов и действовать по нашей рекомендации</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[378]">{{service.cf[378]}} руб</span>
                <span class="box-item__price" v-else>299 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn" id="btn1" @click="selectPrice((service.cf[375]?service.cf[375]:'Выиграю дело сам'),(service.cf[378]?service.cf[378]:299),1)"><span>Заказать документы</span></button>
                </div>
              </div>
            </div>
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[379]">{{service.cf[379]}}</h4>
              <h4 class="box-item__header" v-else>Подскажите как</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[380]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[380].split('\n')" :key="i">{{cf}}</li>
                  </slot>
                  <slot v-else>
                  <li>10 комплектов документов</li>
                  <li>Видеоразбор и урок по возврату ав в Вашей ситуации</li>
                  <li>Персональный разбор Вашего дела</li>
                  </slot>
                </ul>
                <p class="box-item__text" v-if="service.cf[381]">{{service.cf[381]}}</p>
                <p class="box-item__text" v-else>
                  Самый популярный тариф. Вы разберетесь во всем сами и без труда решите свой вопрос</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[382]">{{service.cf[382]}} руб</span>
                <span class="box-item__price" v-else>499 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn" id="btn2" @click="selectPrice((service.cf[379]?service.cf[379]:'Подскажите как'),(service.cf[382]?service.cf[382]:499),1)"><span>Заказать документы</span></button>
                </div>
              </div>
            </div>
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[383]">{{service.cf[383]}}</h4>
              <h4 class="box-item__header" v-else>Дайте все готовое</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[384]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[384].split('\n')" :key="i">{{cf}}</li>
                    <li>Полная подготовка всех необходимых документов, доказательств и других материалов</li>
                  </slot>
                  <slot v-else>
                  <li>1 час видеоконсультации с юристом</li>
                  <li>Персональный разбор Вашего дела</li>
                  <li>Юрист подготовит и сделает всё сам</li>
                  <li>Что то четвертое</li>
                  </slot>
                </ul>
                <p class="box-item__text" v-if="service.cf[385]">{{service.cf[385]}}</p>
                <p class="box-item__text" v-else>
                  Премиум-тариф – специалист все сделает за вас, напомнит о нужных действиях и будет всегда на связи</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[386]">{{service.cf[386]}} руб</span>
                <span class="box-item__price" v-else>2499 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn" id="btn3" @click="selectPrice((service.cf[383]?service.cf[383]:'Дайте все готовое'),(service.cf[386]?service.cf[386]:2499),1)"><span>Заказать документы</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="history" v-if="service.cf[387] || service.cf[388] || service.cf[389] || service.cf[390] || service.cf[391] || service.cf[392] || service.cf[401] || service.cf[402]">
      <div class='container'>
        <div class="history__wrapper">
          <h3 class="history__title">Истории выигранных дел</h3>
          <div class="history__item item-history">
            <div class="item-history__block" v-if="service.cf[387] || service.cf[388]">
              <h5 class="item-history__title" v-if="service.cf[387]">{{service.cf[387]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[388]">{{service.cf[388]}}</p>
            </div>
            <div class="item-history__block" v-if="service.cf[389] || service.cf[390]">
              <h5 class="item-history__title" v-if="service.cf[389]">{{service.cf[389]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[390]">{{service.cf[390]}}</p>
            </div>
            <div class="item-history__block" v-if="service.cf[391] || service.cf[392]">
              <h5 class="item-history__title" v-if="service.cf[391]">{{service.cf[391]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[392]">{{service.cf[392]}}</p>
            </div>
            <div class="item-history__block" v-if="showAll">
              <h5 class="item-history__title" v-if="service.cf[401]">{{service.cf[401]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[402]">{{service.cf[402]}}</p>
            </div>
            <div class="item-history__link-wrapper" v-if="!showAll && (service.cf[401] || service.cf[402])">
              <a  class="item-history__link" @click="showAll = true"><span>Читать ещё</span></a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="for-whom whom-for">
      <div class="for-whom__head">
        <div class="for-whom__head-icon"></div>
        <div class="for-whom__head-title">Хочу получить ходатайства бесплатно</div>
        <div class="for-whom__head-email">
          <input autocomplete="off" type="email" name="form[]" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
          <button @click="sendQuestion('ходатайства')"><span>Получить</span></button>
        </div>
      </div>
      <div class='container'>
        <div class="for-whom__wrapper">
          <h1 class="for-whom__title">Для кого</h1>
          <ul class="for-whom__list">
            <li v-if="service.cf[393]">{{service.cf[393]}}</li><li v-else>Для тех, кому суд еще не назначили</li>
            <li v-if="service.cf[394]">{{service.cf[394]}}</li><li v-else>Для тех, кому суд уже назначили и времени мало</li>
            <li v-if="service.cf[395]">{{service.cf[395]}}</li><li v-else>Для тех, у кого суд был проигран, права сданы</li>
            <li v-if="service.cf[396]">{{service.cf[396]}}</li><li v-else>Для тех, у кого суд был проигран, права не сданы</li>
            <li v-if="service.cf[397]">{{service.cf[397]}}</li>
          </ul>
          <div class="whom-for__btn-wrapper">
            <a class="whom-for__btn" href="#ya1"><span>Буду действовать</span></a>
          </div>
        </div>
      </div>
    </section>
    <section class="popup popup-reg is-active" v-if="text">
      <div class="popup__wrapper">
        <div class="popup__inner">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" type="button" @click="text=null, price=null"></button>
            <h4 class="popup__title">{{text}}</h4>
            <span class="popup__price" v-if="price">{{price}} руб</span>
            <div>
              <div class="form-popup">
                <div class="popup-line" v-if="group.name">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{group.name}}</span></div>
                </div>
                <div class="popup-line" v-if="service.cf[403]">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{service.cf[403]}}</span></div>
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" placeholder="Город" class="input input__city" v-model="city">
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" placeholder="Имя" class="input input__name" v-model="name">
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="tel" placeholder="Телефон" class="input input__tel" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" >
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="email" placeholder="E-mail" class="input input__email" v-model="email" data-inputmask="'alias': 'email'">
                </div>
                <div class="popup-send-btn-wrapper">
                  <button class="popup-send-btn" @click="sendQuestion">Получить документы по моему делу</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  import axios from '@/router/http'
  import Inputmask from 'inputmask'
  import $ from 'jquery'
  export default {
    name: 'service',
    data () {
      return {
        service: {
          cf: {},
          id: {}
        },
        group: { cf: {} },
        showAll: false,
        text: null,
        name: null,
        price: null,
        email: null,
        phone: null,
        city: null,
        urist: null
      }
    },
    methods: {
      initPage () {
        axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.service = response.data
          if (!this.service.cf) this.service.cf = {}
          if (this.service.cf[341]) {
            axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.service.cf[341]).then(response => {
              this.group = response.data
              if (!this.group.cf) this.group.cf = {}
            })
          }
        })
        var self = this
        $(document).mouseup(function (e) {
          var container = $('.popup__content')
          if (container.has(e.target).length === 0) {
            self.text = null
          }
        })
      },
      referenceModal () {
        let vm = 1
        if ((window.location.href === 'https://avtourist.net/services/' + this.service.id + '#requestModal1') && vm === 1) {
          $('#btn1').trigger('click')
          vm = 2
        } else if ((window.location.href === 'https://avtourist.net/services/' + this.service.id + '#requestModal2') && vm === 1) {
          $('#btn2').trigger('click')
          vm = 2
        } else if ((window.location.href === 'https://avtourist.net/services/' + this.service.id + '#requestModal3') && vm === 1) {
          $('#btn3').trigger('click')
          vm = 2
        }
      },
      selectPrice (name, price, urist) {
        this.text = name
        this.price = price
        this.urist = urist
        Inputmask().mask(document.querySelectorAll('input'))
        setTimeout(() => {
          Inputmask().mask(document.querySelectorAll('input'))
        }, 1000)
      },
      sendQuestion (e) {
        if (e === 'ходатайства') {
          var formDataHodataistva = new FormData()
          formDataHodataistva.append('crm', '9')
          formDataHodataistva.append('pipe', '17')
          formDataHodataistva.append('contact[142]', this.email)
          formDataHodataistva.append('lead[404]', 'ходатайства в суд и не только')
          formDataHodataistva.append('lead[145]', 'ходатайства в суд и не только')
          return axios.post('https://urist1.v-avtoservice.com/api/import-lead',
            formDataHodataistva,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else this.$refs.modalSubscribe.style.display = 'block'
          })
        }
        if (!this.email) alert('Вам необходимо указать E-mail')
        else if (!this.phone) alert('Вам необходимо указать Телефон')
        else {
          // eslint-disable-next-line
          if (this.urist || 1 === 1) {
            setTimeout(() => {
              var formData = new FormData()
              formData.append('crm', '11')
              formData.append('pipe', '22')
              formData.append('contact[name]', this.name)
              formData.append('contact[199]', this.phone)
              formData.append('contact[200]', this.email)
              formData.append('contact[207]', this.city)
              formData.append('lead[price]', this.price)
              formData.append('lead[204]', this.city)
              formData.append('lead[214]', 'avtourist.net')
              formData.append('note', 'Группа: ' + this.group.name + '<br> Услуга: ' + this.service.name)

              axios.post('https://urist.v-avtoservice.com/api/import-lead',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(res => {
                if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
                else this.$refs.modalSubscribe.style.display = 'block'
              })
            }, 1)
          }
          var formData = new FormData()
          formData.append('crm', '9')
          formData.append('pipe', '17')
          formData.append('contact[name]', this.name)
          formData.append('contact[141]', this.phone)
          formData.append('contact[142]', this.email)
          formData.append('contact[143]', this.city)
          formData.append('lead[price]', this.price)
          formData.append('lead[147]', this.city)
          formData.append('lead[404]', this.group.name)
          formData.append('lead[145]', this.service.name)
          axios.post('https://urist1.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else this.$refs.modalSubscribe.style.display = 'block'
          })
        }
      },
      playYouTube () {
        // Вытаскиваем из атрибута ID видео
        let iframe1 = document.getElementById('div1')
        let id = iframe1.getAttribute('src')
        let videos
        const videoID = id.split('/').pop()
        if (!document.getElementsByClassName) {
          // Поддержка IE8
          let getElementsByClassName = function (node, classname) {
            let a = []
            let re = new RegExp('(^| )' + classname + '( |$)')
            let els = node.getElementsByTagName('*')
            for (let i = 0, j = els.length; i < j; i++) {
              if (re.test(els[i].className))a.push(els[i])
            return a
            }
          }
          videos = getElementsByClassName(document.body, 'youtube')
        } else {
          videos = document.getElementsByClassName('youtube')
        }
        let nbVideos = videos.length
        for (let i = 0; i < nbVideos; i++) {
          // Находим постер для видео по ID видео
          videos[i].style.backgroundImage = 'url(http://i.ytimg.com/vi/' + videoID + '/sddefault.jpg)'
          // Размещаем над постером кнопку Play, чтобы создать эффект плеера
          let play = document.createElement('div')
          play.setAttribute('class', 'play')
          videos[i].appendChild(play)
          // По клику открыть модальное окно
          videos[i].onclick = function () {
            let modal = document.getElementById('youtubeModal')
            modal.classList.add('youtube-modal_BG')
            // Создаем iFrame и сразу начинаем проигрывать видео, т.е. атрибут autoplay=1
            let iframe = document.createElement('iframe')
            iframe.classList.add('youtube-modal')
            let iframeUrl = 'https://www.youtube.com/embed/' + videoID + '?autoplay=1&autohide=1'
            if (this.getAttribute('data-params')) iframeUrl += '&' + this.getAttribute('data-params')
            iframe.setAttribute('src', iframeUrl)
            iframe.setAttribute('frameborder', '0')
            // Высота и ширина iFrame будет как у элемента-родителя
            iframe.style.width = '50vw'
            iframe.style.height = '50vh'
            // При клике в любое место кроме плеера модальное окно закрывается
            window.onclick = function (event) {
              if (event.target === modal) {
                iframe.classList.remove('youtube-modal')
                modal.classList.remove('youtube-modal_BG')
                iframe.style.width = '100%'
                iframe.style.height = '100%'
              }
            }
            // Заменяем начальное изображение (постер) на iFrame
            this.parentNode.replaceChild(iframe, this)
          }
        }
      },
      invisibleDocs () {
        $(function () {
          let maxHeight = '1200px'
          if (window.innerWidth <= 995) {
            maxHeight = '2400px'
          }
          let copy = $('#one').clone().attr('id', 'onecopy').css({
            'width': '430px',
            'margin-top': '-595px',
            'height': maxHeight,
            'border': 'none'
          })
          $('#two').append(copy)
        })
      }
    },
    mounted () {
      setTimeout(() => { this.playYouTube() }, 1500)
      this.initPage()
      setTimeout(() => { this.invisibleDocs() }, 2500)
      setTimeout(() => {
        this.referenceModal()
      }, 1500)
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>
  .invisible-docs {
    position: relative;
  }
  .invisible-docs__arr {
    position: absolute;
    left: 49.7%;
    top: -50px;
    font-size: 24px;
    display: inline-block;
    transform: rotate(-90deg)scale(1.3, 2.3);
    color: #797979;
  }
  .mydiv1 {
    float: left;
    background: #fff;
    width: 430px;
    height: 600px;
    border: 1px solid #B8B8B8;
    overflow: hidden;
    margin: 0 10px;
    padding: 15px;
  }
  .mydiv2 {
    float: left;
    background: #fff;
    width: 430px;
    height: 600px;
    border: 1px solid #B8B8B8;
    overflow: hidden;
    margin: 0 10px;
    padding: 15px 0;
    position: relative;
  }
  .mydiv2::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15px;
    background-color: #ffffff;
  }
 .popup-line .nice-select::after {
   display: none;
 }
 .text {
   height: 600px;
   position: relative;
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   margin-bottom: 23px;
 }
  .text::before {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #797979;
    max-width: 880px;
    position: absolute;
    top: -20px;
  }
  .invisible-docs__title {
    position: absolute;
    left: 50px;
    bottom: 120px;
    z-index: 2;
  }
.invisible-docs__title p {
  font-size: 20px;
  font-weight: 600;
}
  .invisible-docs__title-next {
    font-size: 24px;
    display: inline-block;
    transform: rotate(90deg)scale(1.3, 2.3);
    left: 150px;
    position: absolute;
    color: #797979;
  }
.invisible-docs__title p span {
 color: #797979;
 font-size: 14px;
 font-weight: 500;
}
@media (max-width: 995px) {
 .text {
   height: initial;
 }
 .mydiv1,
 .mydiv2 {
   margin: 0 auto;
   margin-bottom: 15px;
 }
}
.text-open .toggle {
 display: none;
}
.toggle {
 background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0) 0%, #fff 60%);
 background-image: -moz-linear-gradient(rgba(255, 255, 255, 0) 0%, #fff 60%);
 background-image: -o-linear-gradient(rgba(255, 255, 255, 0) 0%, #fff 60%);
 background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, #fff 60%);
 position: absolute;
 right: 5px;
 bottom: 0px;
 width: 100%;
 height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/service.vue